import {
  DiscountGroupType,
  ExpirationType,
} from "@redotech/redo-discounts-common/discount";
import {
  DiscountCategory,
  RedoDiscount,
} from "@redotech/redo-discounts-common/discount/discount-db-parser";
import {
  dateToCurrentPlainDate,
  plainDateToCurrentDate,
} from "@redotech/util/temporal";
import { RedoSingleDatePicker } from "../../../arbiter-components/date-picker/redo-single-date-picker";
import { RedoTextInput } from "../../../arbiter-components/input/redo-text-input";
import { RedoRadioGroup } from "../../../arbiter-components/radio/redo-radio-group";
import { Flex } from "../../../flex";
import { LabeledInput, LabelSize } from "../../../labeled-input";
import { Text } from "../../../text";
import { getDefaultExpiration } from "../constants";

export function ExpirationField({
  expiration,
  setExpiration,
  codeGenerationStrategy,
  category,
}: {
  expiration: RedoDiscount["expiration"];
  setExpiration: (expiration: RedoDiscount["expiration"]) => void;
  codeGenerationStrategy: DiscountGroupType;
  category?: DiscountCategory;
}) {
  return (
    <>
      <LabeledInput
        label={
          <Text fontSize="xs" fontWeight="medium" textColor="secondary">
            Expiration
          </Text>
        }
        size={LabelSize.EXTRA_SMALL}
      >
        {category !== DiscountCategory.RECOVER ? (
          <RedoRadioGroup<ExpirationType>
            options={[
              { id: ExpirationType.NEVER, label: "Never" },
              ...(codeGenerationStrategy === DiscountGroupType.DYNAMIC
                ? [{ id: ExpirationType.EXPIRATION_DAYS, label: "Days" }]
                : []),
              { id: ExpirationType.DATE, label: "Date" },
            ]}
            setValue={(value) => {
              setExpiration(getDefaultExpiration(value));
            }}
            size="xs"
            value={expiration.expirationType}
          />
        ) : (
          expiration.expirationType === ExpirationType.NEVER && (
            <Text fontSize="xs" textColor="secondary">
              Never
            </Text>
          )
        )}
      </LabeledInput>

      {expiration.expirationType === ExpirationType.EXPIRATION_DAYS && (
        <Flex>
          <RedoTextInput
            inputTypeHint="number"
            label="Number of days"
            min={1}
            placeholder="Enter days"
            setValue={(value) =>
              setExpiration({ ...expiration, days: Number(value) })
            }
            step={1}
            value={expiration.days?.toString() || ""}
          />
        </Flex>
      )}

      {category !== DiscountCategory.RECOVER &&
        expiration.expirationType === ExpirationType.DATE && (
          <Flex>
            <RedoSingleDatePicker
              buttonSize="sm"
              date={dateToCurrentPlainDate(expiration.date)}
              setDate={(date) =>
                setExpiration({
                  ...expiration,
                  date: plainDateToCurrentDate(date),
                })
              }
            />
          </Flex>
        )}
    </>
  );
}
